import React from "react";
import AboutboxImg from '../../assets/about-image.webp';

const AboutUs = () => {

    return (<>
        <section className="about_section-1">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="section-title col-md-12 mb-5">
                        <h1 className="seo_t">About Us</h1>
                        <p>- Get the Road Service -</p>
                        <h2>How Can We Help You?</h2>
                    </div>

                    <div className="col-md-4 mb-3 mb-md-0">
                        <div className="about_service h-100">
                            <span className="ico-high">
                                <i className="fa fa-cogs" title="choose-your-service"></i>
                            </span>
                            <h2>Choose your service</h2>
                            <p>The first step is to select the service you need
                                (e.g., truck repairs, towing, truck trailer repairs).
                                If you're looking for "<a href="https://onlineroadservices.com/plans">truck service near you,</a>" we offer
                                reliable tow truck services and expert roadside help.
                                Online Road Services is here to quickly reduce your
                                downtime efficiently.</p>
                        </div>
                    </div>

                    <div className="col-md-4 mb-3 mb-md-0">
                        <div className="about_service h-100">
                            <span className="ico-high">
                                <i className="fa fa-street-view" title="where-you-are"></i>
                            </span>
                            <h2>Where you are?</h2>
                            <p>
                            Choose your location to find reliable service providers
                            near you. Online Road Services connects you with trusted
                            professionals for heavy duty truck repair to commercial
                            truck repair nationwide. Wherever you are, rely on us for
                            the right road service to keep you moving.
                            </p>
                        </div>
                    </div>

                    <div className="col-md-4 mb-3 mb-md-0">
                        <div className="about_service h-100">
                            <span className="ico-high">
                                <i className="fa fa-flag" title="suits-you-the-best"></i>
                            </span>
                            <h2>Suits you the best</h2>
                            <p>
                            Online Road Service lists nearby repair shops and service providers
                            based on your selected truck maintenance service. You’ll get contact
                            details and distance from your location, making it easy to choose the
                            right fit—whether for routine maintenance or urgent help
                            like <a href="https://onlineroadservices.com/blogs">semi towing near you</a>.
                            </p>
                        </div>
                    </div>

                </div>
            </div>
        </section>

        <section className="about_section-2">
            <div className="container">
                <div className="row justify-content-center align-items-center">

                    <div className="col-md-6">
                        <div className="about_img_box">
                            <img src={AboutboxImg} className='img-fluid' alt='Stuck-in-an-emergency' loading='lazy'/>
                        </div>
                    </div>


                    <div className="col-md-6 about-col-text text-left">
                        <h6>We are here to help!</h6>
                        <h3>Stuck In An Emergency?</h3>
                        <h4>"Stay Updated And Ready For Any Emergency With Online Road Services As Your Companion."</h4>
                        <p>Got a tire blowout? Do you need emergency reefer repair? Are you looking for the nearest truck stop?
                            No matter what leaves you stranded, or whatever your breakdown service is. You will find the information
                            you require on Online road service. We understand the distress,which is why we provide you with the
                            necessary assistance instantly. You can count on us to get you back moving as soon as possible.
                            From truck and trailer repair to routine maintenance, our platform connects you with reliable
                            service providers near you. No matter where you are, help is just a click away! </p>
                    </div>
                </div>
            </div>
        </section>

    </>
    );
};

export default AboutUs;